import React, { useState } from 'react';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { BannerImg, BannerImg1, ExperienceImg1, ExperienceImg2, GlobalIcon, LocalIcon, ServiceImg1, ServiceImg2, ServiceImg3, ServiceImg4, ServiceImg5, ChooseUsImg, TestimonialImg1, NewsImg1, NewsImg2, NewsImg3, NewsImg4, ArrowRightIcon, MapImg2 } from '../../Constant/Index';
// Range Slider In Choose Us Form
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
// End Here
// SLick Slider Lirbaries Imported Here
import Slider from 'react-slick'
import { FaChevronLeft, FaChevronRight } from 'react-icons'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { Link } from 'react-router-dom';


const Home = () => {
    const [ActiveFilter, setActiveFilter] = useState(1);
    const filterList = ["Our Mission", "Our Vision", "Our Value"];
    const changeFilter = (filterIndex) => {
        setActiveFilter(filterIndex);
    };
    const sliderSettings = {
        // removes default buttons
        arrows: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            }
        ]
    }


    const [value, setValue] = useState([30, 60]);
    const [sliderRef, setSliderRef] = useState(null)
    const Services = [
        {
            id: 1,
            Name: "Air Freight",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
            Img: ServiceImg1
        },
        {
            id: 2,
            Name: "Ocean Freight",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
            Img: ServiceImg2
        },
        {
            id: 3,
            Name: "Custom Brokerage",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
            Img: ServiceImg3
        },
        {
            id: 4,
            Name: "Warehousing ",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
            Img: ServiceImg4
        },
        {
            id: 5,
            Name: "Special Cargo",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
            Img: ServiceImg5
        },
    ];
    const NewsData = [
        {
            Name: "Ocean Freight ",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            Img: NewsImg1
        },
        {
            Name: "Air Freight",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            Img: NewsImg2
        },
        {
            Name: "Warehousing",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            Img: NewsImg3
        },
        {
            Name: "Custom Brokerage",
            Para: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
            Img: NewsImg4
        },

    ];
    const Testimonials = [0, 1, 2, 3, 4, 5, 7];
    return (
        <>
            <Header />
            {/* Banner Start Here */}
            <section className="banner-section">
                <div className="container-fluid px-0">
                    <div className="banner-slider-start">
                        <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-indicators">
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                            </div>
                            <div class="carousel-inner">
                                <div className="carousel-item active">
                                    <img src={BannerImg} className="d-block w-100 slider-img" alt="..." />
                                    <div className="carousel-caption d-md-block w-100 p-0 custom-caption">
                                        <div className="row mx-0 h-100">
                                            <div className="col-xl-6 col-lg-7 col-md-7 col-sm-8 ps-0 pe-xl-4 pe-xxl-5 h-100 position-relative custom-width">
                                                <div className="blue-section primary-text ">
                                                    <h1 className='main-heading captalize-text'>Taking Logistics to one step above</h1>
                                                    <p className='text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.</p>
                                                    <a href="" className="btn main-text primary-bg ">Get Started</a>
                                                    <figure className='man-image position-absolute bottom-0'>
                                                        <img src={BannerImg1} alt="" />
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <img src={BannerImg} className="d-block w-100 slider-img" alt="..." />
                                    <div className="carousel-caption d-md-block w-100 p-0 custom-caption">
                                        <div className="row mx-0 h-100">
                                            <div className="col-xl-6 col-lg-7 col-md-7 col-sm-8 ps-0 pe-xl-4 pe-xxl-5 h-100 position-relative custom-width">
                                                <div className="blue-section primary-text ">
                                                    <h1 className='main-heading captalize-text'>Taking Logistics to one step above</h1>
                                                    <p className='text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.</p>
                                                    <a href="" className="btn main-text primary-bg ">Get Started</a>
                                                    <figure className='man-image position-absolute bottom-0'>
                                                        <img src={BannerImg1} alt="" />
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <img src={BannerImg} className="d-block w-100 slider-img" alt="..." />
                                    <div className="carousel-caption d-md-block w-100 p-0 custom-caption">
                                        <div className="row mx-0 h-100">
                                            <div className="col-xl-6 col-lg-7 col-md-7 col-sm-8 ps-0 pe-xl-4 pe-xxl-5 h-100 position-relative custom-width">
                                                <div className="blue-section primary-text ">
                                                    <h1 className='main-heading captalize-text'>Taking Logistics to one step above</h1>
                                                    <p className='text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.</p>
                                                    <a href="" className="btn main-text primary-bg ">Get Started</a>
                                                    <figure className='man-image position-absolute bottom-0'>
                                                        <img src={BannerImg1} alt="" />
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="banner-section">
                <div className="container-fluid px-0">
                    <div className="banner-slider-start">
                        <div id="carouselExampleCaptions" className="carousel slide">
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <img src={BannerImg} className="d-block w-100 slider-img" alt="..." />
                                    <div className="carousel-caption d-md-block w-100 p-0 custom-caption">
                                        <div className="row mx-0 h-100">
                                            <div className="col-xl-6 col-lg-7 col-md-7 col-sm-8 ps-0 pe-xl-4 pe-xxl-5 h-100 position-relative custom-width">
                                                <div className="blue-section primary-text ">
                                                    <h1 className='main-heading captalize-text'>Taking Logistics to one step above</h1>
                                                    <p className='text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.</p>
                                                    <a href="" className="btn main-text primary-bg ">Get Started</a>
                                                    <figure className='man-image position-absolute bottom-0'>
                                                        <img src={BannerImg1} alt="" />
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            {/* Banner End Here */}
            {/* Experience Section Start Here */}
            <section className="experience-section">
                <div className="container">
                    <div className="experience-start">
                        <div className="row">
                            <div className="col-lg-6 col-md-12 ">
                                <div className="experience-right-data">
                                    <figure className='experience-images order-1'>
                                        <img src={ExperienceImg1} alt="" className="top-left-img" />
                                        <img src={ExperienceImg2} alt="" className="bottom-right-img" />
                                    </figure>
                                    <div className="experience-box primary-text order-0 mb-3 mb-md-0">
                                        <div className="headings">
                                            <h2 className="md-heading">25+</h2><h6 className="xs-heading small">Year</h6>
                                        </div>
                                        <p className="text crop-2-lines">We Have More than years of Experience</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 ps-xxl-4">
                                <div className="experience-about">
                                    <div className="top-text">
                                        <span className="top-small-heading uppercase-text">About</span>
                                        <h3 className="md-heading w-75">Proud to Deliver Excellence Every Time</h3>
                                        <p className="text exp-color">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                                    </div>
                                    <div className="experience-in mt-3">
                                        <div className="row">
                                            <div className="col-md-6 pe-xxl-4 order-1 order-md-0 mt-4 mt-md-0">
                                                <div className="the-text">
                                                    <p className="text exp-color">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p>
                                                    <a href="" className="btn mt-4">Explore More</a>
                                                </div>
                                            </div>
                                            <div className="col-md-6 ps-0 order-0 order-md-1">
                                                <div className="experience-box">
                                                    <div className="single-box">
                                                        <figure>
                                                            <img src={GlobalIcon} alt="" className="icon" />
                                                        </figure>
                                                        <div className="the-data">
                                                            <h6 className="xs-heading small mb-0">Global Service</h6>
                                                            <p className='text mb-0'>Lorem ipsum dolor sit amet, consectetur sed do eiusmod</p>
                                                        </div>
                                                    </div>
                                                    <div className="single-box">
                                                        <figure>
                                                            <img src={LocalIcon} alt="" className="icon" />
                                                        </figure>
                                                        <div className="the-data">
                                                            <h6 className="xs-heading small mb-0">Local Service</h6>
                                                            <p className='text mb-0'>Lorem ipsum dolor sit amet, consectetur sed do eiusmod</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Experience Section End Here */}
            {/* Services Section Start Here */}
            <section className="services-section">
                <div className="container">
                    <div className="services-list">
                        <div className="row align-items-center">
                            <div className="col-lg-4 col-md-6 col-sm-6 mt-5 px-xl-3">
                                <div className="service-blue-box primary-text">
                                    <span className="small-top-heading uppercase-text">Services</span>
                                    <h3 className='md-heading'>Let us Take the stress out of your move.</h3>
                                    <p className="crop-3-lines text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
                                </div>
                            </div>
                            {
                                Services.map((service, index) => (
                                    <div className="col-lg-4 col-md-6 col-sm-6 col-6 mt-5 px-xl-3" key={index}>
                                        <div className="single-service">
                                            <h4 className="sm-heading">{service.Name}</h4>
                                            <div className="the-text">
                                                <p className='text crop-2-lines'>{service.Para} <Link to={"/service-detials/" + service.id} className='read-more'>Read More</Link></p>
                                            </div>
                                            <figure className="serivce-img">
                                                <img src={service.Img} alt="" className="the-img w-100" />
                                            </figure>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </section>
            {/* Services Section End Here */}
            {/* CHoose Use Section Start Here */}
            <section className="choseus-section">
                <div className="container">
                    <div className="col-xl-10 mx-auto">
                        <div className="chose-us-start">
                            <div className="row">
                                <div className="col-lg-9 mx-auto col-md-12">
                                    <div className="chose-us-text">
                                        <div className="top-heading">
                                            <span className="small-top-heading">Why Choose Us?</span>
                                            <h2 className="md-heading">We Create opportunity To Reach Potential.</h2>
                                        </div>
                                        <ul className="filter-options mx-auto">
                                            {filterList.map((filter, index) => (
                                                <li className='single-filter' key={index}><button className={`filter-btn ${(index == ActiveFilter) ? " active" : ""}`} onClick={() => changeFilter(index)}>{filter}</button></li>
                                            ))}
                                        </ul>
                                        <div className="filter-data pt-4">
                                            <div className="single-data">
                                                <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation</p>
                                                <div className="text-image">
                                                    <div className="row">
                                                        <div className="col-sm-6 col-6">
                                                            <figure className="data-image">
                                                                <img src={ChooseUsImg} alt="" className="the-image w-100" />
                                                            </figure>
                                                        </div>
                                                        <div className="col-sm-6 col-6">
                                                            <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                                                <br />
                                                                <br />
                                                                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-lg-5 col-md-12">
                                    <div className="choose-form">
                                        <div className="absolute-form">
                                            <form className='custom-from'>
                                                <div className="row">
                                                    <div className="col-md-12 mt-4">
                                                        <div className="from-group">
                                                            <label htmlFor="" className="custom-label">Ocean Freight:</label>
                                                            <select name="" id="" className="form-select form-control">
                                                                <option value="Select">Select</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mt-4">
                                                        <div className="from-group">
                                                            <label htmlFor="" className="custom-label">Load:</label>
                                                            <select name="" id="" className="form-select form-control">
                                                                <option value="Select">Select</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mt-4">
                                                        <div className="row">
                                                            <div className="col-md-9">
                                                                <div className="form-group">
                                                                    <label htmlFor="" className="custom-label">DIST (Miles)</label>
                                                                    <RangeSlider />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="" className='custom-label'></label>
                                                                    <input type="text" name="" id="" className="form-control" placeholder="0-1500" aria-describedby="helpId" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mt-4">
                                                        <div className="form-group">
                                                            <label htmlFor="" className="custom-label">Your Name:</label>
                                                            <input type="text" className="form-control" name='' id='' placeholder='Name' />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mt-4">
                                                        <div className="form-group">
                                                            <label htmlFor="" className="custom-label">Phone:</label>
                                                            <input type="text" className="form-control" name='' id='' placeholder='+1 234 567 8910' />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mt-4">
                                                        <div className="form-group">
                                                            <label htmlFor="" className="custom-label">Message:</label>
                                                            <textarea className="form-control form-md-control" name='' id='' placeholder='Message' ></textarea>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mt-4">
                                                        <button className="btn bg-transparent" type='submit'>Get a Quote</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* CHoose Use Section End Here */}
            {/* Testimonials Section Start Here */}
            <section className="testimonial-section">
                <div className="container">
                    <div className="testimonials-list">
                        <Slider ref={setSliderRef} {...sliderSettings}>
                            <div className="testimonial-text">
                                <span className="top-small-heading uppercase-text">Client Testimonials</span>
                                <h3 className="md-heading captalize-text">Have a look at what Our client say </h3>
                                <a href="" className="btn">Explore More</a>
                            </div>
                            {
                                Testimonials.map((data, index) => (
                                    <div className="single-testimonials" key={index}>
                                        <div className="top-bar">
                                            <div className="user-profile">
                                                <figure className="user-image">
                                                    <img src={TestimonialImg1} alt="" className="the-image" />
                                                </figure>
                                                <div className="user-name">
                                                    <h6 className="xs-heading crop-1-lines">Kristina Bailey</h6>
                                                    <span className="role">Customer</span>
                                                </div>
                                            </div>
                                            <span className="posting-time">Posted a week ago</span>
                                        </div>
                                        <div className="testimonial-body">
                                            <p className="text crop-4-lines">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Nisi est sit amet facilisis. Tempor id eu nisl nunc. Gravida dictum fusce ut placerat orci. Id consectetur purus.</p>
                                        </div>
                                    </div>
                                ))
                            }

                        </Slider>
                    </div>
                </div>
            </section>
            {/* Testimonials Section End Here */}
            {/* News Section Start Here */}
            <section className="news-section">
                <div className="container">
                    <div className="news-start-here">
                        <div className="top-headings text-center  mx-auto">
                            <span className="small-heading">News</span>
                            <h3 className="md-heading">Let’s Checkout Our All Latest News</h3>
                            <p className='text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
                        </div>
                        <div className="news-list">
                            <div className="row">
                                {
                                    NewsData.map((Single, index) => (
                                        <div className="col-lg-3 col-md-6 col-sm-6 mt-3">
                                            <div className="single-news">
                                                <figure className='news-image'>
                                                    <img src={Single.Img} alt="" className="the-image w-100" />
                                                </figure>
                                                <div className="news-body">
                                                    <h5 className="xs-heading crop-1-lines">{Single.Name}</h5>
                                                    <p className='text crop-2-lines'>{Single.Para}</p>
                                                    <span className="date">March 8,2023</span>
                                                    <Link to="/news-details" className='news-link'><img src={ArrowRightIcon} alt="" /></Link>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* News Section End Here */}
            {/* Contact Section start Here */}
            <section className="index-contact-section">
                <div className="container">
                    <div className="contact-start">
                        <div className="row">
                            <div className="col-xxl-4 col-xl-5 col-lg-5 col-md-5">
                                <div className="contact-details">
                                    <div className="top-text">
                                        <h5 className="sm-heading captalize-text">our contact details</h5>
                                        <div className="current-hq">
                                            <div className="md-text">Los Angeles, CA <span>(Headquarter)</span></div>
                                        </div>
                                        <ul className="contact-lis">
                                            <li className='contact-item'><i className="icon fa fa-map-marker"></i><span className='contact-info' >2760 EAST EL PRESIDIO ST CARSON, CA 90810</span></li>
                                            <li className='contact-item'><i className="icon fa fa-envelope"></i><a className='contact-info' href="mailto: Lax@webtransusa.com">Email: Lax@webtransusa.com</a></li>
                                            <li className='contact-item'><i className="icon fa fa-phone"></i><a className='contact-info' href="tel: (310) 522 6666">Tel: (310) 522 6666</a></li>
                                        </ul>
                                    </div>
                                    <div className="map-here mt-4">
                                        {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6999584.908037069!2d-105.36941405478338!3d31.060611276577166!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864070360b823249%3A0x16eb1c8f1808de3c!2sTexas%2C%20USA!5e0!3m2!1sen!2s!4v1688547942513!5m2!1sen!2s"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                                        <img src={MapImg2} alt="" width="100%" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-8 col-xl-7 col-lg-7 col-md-7 mt-lg-0 mt-4 d-flex flex-column justify-content-center">
                                <div className="contact-index-form">
                                    <form className='custom-from'>
                                        <h5 className="sm-heading mb-1">Send Message without any hesitation</h5>
                                        <div className="row">
                                            <div className="col-md-6 mt-3">
                                                <div className="form-group">
                                                    <label htmlFor="" className="custom-label">First Name</label>
                                                    <input type="text" className="form-control" name='' id='' placeholder='First Name' />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <div className="form-group">
                                                    <label htmlFor="" className="custom-label">Last Name</label>
                                                    <input type="text" className="form-control" name='' id='' placeholder='Last Name' />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <div className="form-group">
                                                    <label htmlFor="" className="custom-label">Email Address</label>
                                                    <input type="email" className="form-control" name='' id='' placeholder='Email Address' />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <div className="form-group">
                                                    <label htmlFor="" className="custom-label">Contact Number</label>
                                                    <input type="text" className="form-control" name='' id='' placeholder='Contact Number' />
                                                </div>
                                            </div>
                                            <div className="col-md-12 mt-3">
                                                <div className="form-group">
                                                    <label htmlFor="" className="custom-label">Message:</label>
                                                    <textarea className="form-control form-md-control" name='' id='' placeholder='Message' ></textarea>
                                                </div>
                                            </div>
                                            <div className="col-md-12 mt-4">
                                                <button className="btn" type='submit'>Submit</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Contact Section End Here */}
            {/* Footer Included Here */}
            <Footer />
            {/* Footer Included Here */}
        </>
    )
}
export default Home;